import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="border-t mt-16 py-8 bg-background/50">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="font-semibold mb-3 text-foreground">{t('categories.general.title')}</h3>
            <div className="flex flex-col gap-2">
              <Link to="/health" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                {t('categories.general.health')}
              </Link>
              <Link to="/lifestyle" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                {t('categories.general.lifestyle')}
              </Link>
              <Link to="/other" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                {t('categories.general.other')}
              </Link>
            </div>
          </div>
          
          <div>
            <h3 className="font-semibold mb-3 text-foreground">{t('categories.science.title')}</h3>
            <div className="flex flex-col gap-2">
              <Link to="/physics" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                {t('categories.science.physics')}
              </Link>
              <Link to="/chemistry" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                {t('categories.science.chemistry')}
              </Link>
              <Link to="/math" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                {t('categories.science.math')}
              </Link>
            </div>
          </div>
          
          <div>
            <h3 className="font-semibold mb-3 text-foreground">{t('categories.finance.title')}</h3>
            <div className="flex flex-col gap-2">
              <Link to="/finance" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                {t('categories.finance.professional')}
              </Link>
              <Link to="/tax" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                {t('categories.finance.tax')}
              </Link>
              <Link to="/loans" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                {t('categories.finance.loans')}
              </Link>
            </div>
          </div>
          
          <div>
            <h3 className="font-semibold mb-3 text-foreground">{t('footer.more')}</h3>
            <div className="flex flex-col gap-2">
              <Link to="/tools" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                {t('categories.tools.title')}
              </Link>
              <Link to="/supercalc" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                {t('nav.superCalc')}
              </Link>
            </div>
          </div>
        </div>
        
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-8 border-t border-border">
          <div className="text-sm text-muted-foreground">
            {t('footer.copyright')}
          </div>
          <div className="flex flex-wrap gap-6 text-sm">
            <Link to="/sitemap" className="text-muted-foreground hover:text-foreground transition-colors">
              {t('footer.sitemap')}
            </Link>
            <Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors">
              {t('footer.terms')}
            </Link>
            <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">
              {t('footer.privacy')}
            </Link>
            <Link to="/support" className="text-muted-foreground hover:text-foreground transition-colors">
              {t('footer.support')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
